export default __webpack_public_path__ + "media/images/screenshot-6dad7559afb050f027ca3c5844b4dc1b.png";